<template>
  <div>
    <my-header></my-header>
    <div class="main_body" v-loading="loading">
      <div class="content">
        <div class="content_title">考试结果</div>
        <el-divider></el-divider>
        <div class="content_name">考试名称：{{ examObj && examObj.exerciseName }}</div>
        <div class="content_time">
          <span style="font-size: 14px; color: #999999">交卷时间：{{ examObj && examObj.assignmentTime }}</span>
          <span
            style="font-size: 14px; margin-left: 20px; color: #999999"
          >答题时长：{{ examObj && examObj.totalTime }}</span>
        </div>
        <div class="content_state" v-if="showScore == 0">
          <div class="content_state_score">{{ examObj && examObj.totalPoints }}</div>
          <div class="content_state_name">得分</div>
        </div>
        <div class="content_state_noScore_pass" v-else-if="showScore == 1">
          <img
            style="width: 100%; height: 100%"
            src="../../../static/20210517new/test_passmain.png"
            alt
          />
        </div>
        <div class="content_state_noScore_unpass" v-else>
          <img
            style="width: 100%; height: 100%"
            src="../../../static/20210517new/test_unpassmain.png"
            alt
          />
        </div>
        <div class="content_footer_yes" v-if="isPass == 1">
          <img
            style="width: 24px; height: 24px"
            src="../../../static/20210517new/test_pass.png"
            alt
          />
          恭喜你!考试通过
        </div>
        <div class="content_footer_no" v-else>
          <img
            style="width: 24px; height: 24px"
            src="../../../static/20210517new/test_unpass.png"
            alt
          />
          很遗憾!考试未通过!
        </div>
        <div style="text-align: center; margin-top: 60px">
          <el-button class="toTestlist" @click="toTestlist" type="primary" plain>我知道了</el-button>
        </div>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import myHeader from "../../components/header.vue";
import myFooter from "../../components/footer.vue";
import { exerciseRecordResult } from "@/apiCloud/otherTestRerult";
export default {
  components: {
    myHeader,
    myFooter
  },
  data() {
    return {
      examObj: {},
      totalPoints: 0,
      totalScore: 0,
      totalNum: 0,
      isRightTotalNum: 0,
      isPass: 0,
      showScore: 0,
      loading: true
    };
  },
  created() {
    this.examObj = JSON.parse(sessionStorage.getItem("examObj"));
    if (
      (this.$route.query.exerciseId != undefined &&
        this.$route.query.exerciseId != "") ||
      this.examObj === null
    ) {
      this.getExamDetail();
    } else {
      this.examObj.paperEntity.paperAreaList.forEach(obj => {
        obj.questionList.forEach(questionObj => {
          if (questionObj.isRight) {
            this.totalPoints = this.totalPoints + questionObj.score;
            this.isRightTotalNum = this.isRightTotalNum + 1;
          }
          this.totalNum = this.totalNum + 1;
          this.totalScore = this.totalScore + questionObj.score;
        });
      });
      this.examObj.totalPoints = this.totalPoints;
      this.examObj.totalScore = this.totalScore;
      this.examObj.totalNum = this.totalNum;
      this.examObj.isRightTotalNum = this.isRightTotalNum;
      this.getShowRule();
      this.loading = false;
    }
  },
  methods: {
    //点击返回考试列表
    toTestlist() {
      this.$router.push({
        path: "/testList"
      });
    },
    //   获取当前试卷考试结果详情
    getExamDetail() {
      let data = {};
      data.exerciseRecordId = this.$route.query.exerciseId;
      exerciseRecordResult(data).then(res => {
        if (res.code == 200) {
          this.loading = false;
          this.examObj = res.data;
          this.examObj.totalTime = this.examObj.totalTime.slice(0, 8);
          this.getShowRule();
        } else {
          this.loading = true;
        }
      });
    },

    getShowRule() {
      if (!this.examObj) {
        return window.alert("未获取到考试结果！");
      }
      if (
        this.examObj.totalPoints &&
        this.$route.query.passScore &&
        this.examObj.totalPoints >= this.$route.query.passScore
      ) {
        this.isPass = 1;
      } else {
        this.isPass = 0;
      }
      if (this.$route.query.detailShow == 1) {
        this.showScore = 0;
      } else {
        if (this.examObj.totalPoints >= this.$route.query.passScore) {
          this.showScore = 1;
        } else {
          this.showScore = 2;
        }
      }
    }
  }
};
</script>

<style scoped>
.toTestlist {
  width: 140px;
  height: 42px;
  margin: auto;
}
.content_footer_no {
  width: 800px;
  height: 24px;
  font-size: 20px;
  margin: auto;
  margin-top: 40px;
  line-height: 28px;
  font-weight: bold;
  color: #999999;
  text-align: center;
}
.content_footer_yes {
  width: 800px;
  height: 24px;
  font-size: 20px;
  margin: auto;
  margin-top: 40px;
  line-height: 28px;
  font-weight: bold;
  color: #39bf6e;
  text-align: center;
}
.content_state {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  margin: auto;
  margin-top: 20px;
  background-color: rgba(73, 143, 255, 0.1);
  overflow: hidden;
}
.content_state_noScore_pass {
  width: 157px;
  height: 148px;
  margin: auto;
  margin-top: 20px;
}
.content_state_noScore_unpass {
  width: 162px;
  height: 148px;
  margin: auto;
  margin-top: 20px;
}
.content_state_score {
  width: 150px;
  height: 64px;
  text-align: center;
  color: #3482ff;
  line-height: 64px;
  font-size: 64px;
  margin-top: 27px;
}
.content_state_name {
  width: 150px;
  height: 16px;
  text-align: center;
  color: #3482ff;
  line-height: 16px;
  margin-top: 17px;
  font-size: 16px;
}
.content_time {
  width: 800px;
  margin: auto;
  text-align: center;
  height: 30px;
  margin-top: 20px;
}
.main_body {
  width: 1200px;
  height: 690px;
  margin: auto;
  overflow: hidden;
}
.content {
  width: 100%;
  height: 690px;
  margin-top: 20px;
  background-color: #fff;
  overflow: hidden;
}
.content_title {
  height: 30px;
  margin-top: 10px;
  font-size: 20px;
  text-indent: 20px;
  font-weight: 700;
  line-height: 30px;
}
.content_name {
  width: 800px;
  height: 30px;
  font-size: 24px;
  color: #333333;
  font-weight: bold;
  text-align: center;
  margin: auto;
  line-height: 24px;
}
</style>


// WEBPACK FOOTER //
// src/pages/otherTestRerult/index.vue